import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { EMPTY_ILLUSTRATION_FLOAT_STYLE, EmptyIllustrationFrame } from './empty-illustration';

interface SectionHubEmptyIllustrationProps {
  icon: LucideIcon;
}

export const SectionHubEmptyIllustration: React.FC<SectionHubEmptyIllustrationProps> = ({
  icon: Icon,
}) => {
  return (
    <EmptyIllustrationFrame size="sm">
      <svg
        viewBox="0 0 104 76"
        className="absolute bottom-0 left-1/2 h-[96px] w-[132px] -translate-x-1/2"
        fill="none"
      >
        <path
          d="M10 12 H46 L58 24 H94 A8 8 0 0 1 102 32 V60 A8 8 0 0 1 94 68 H10 A8 8 0 0 1 2 60 V20 A8 8 0 0 1 10 12 Z"
          fill="var(--muted)"
          stroke="var(--border)"
          strokeWidth="2"
        />
      </svg>
      <div
        className="absolute left-1/2 top-2 flex h-[56px] w-[56px] -translate-x-1/2 items-center justify-center rounded-xl shadow-sm"
        style={{ backgroundColor: 'var(--scribane-green)', ...EMPTY_ILLUSTRATION_FLOAT_STYLE.b }}
      >
        <Icon className="h-6 w-6 text-white" />
      </div>
    </EmptyIllustrationFrame>
  );
};
